<section class="toast-container">
  @for (toast of queue; track trackById($index, toast)) {
    <aside
      class="toast-message"
      [ngClass]="'toast-message--' + toast.type"
      >
      <div class="toast-message__content" [innerHtml]="toast.message"></div>
      <button type="button" class="toast-message__dismiss" (click)="dismiss(toast.id)" aria-label="Dismiss">&times;</button>
    </aside>
  }
</section>
